import React, { Component } from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import { startEditVendor } from '../../../actions/vendorActions';
import PropTypes from 'prop-types';
import VendorForm from './VendorForm';

export class EditVendorPage extends Component {

  onFormActionSubmit = (vendor) => {
    this.props.startEditVendor(vendor.vendor_id, vendor);
  };

  render() {
    return (
      <div>
        <Typography variant="display1" gutterBottom>
          Edit Vendor
        </Typography>
        <VendorForm
          editMode
          onFormActionSubmit={this.onFormActionSubmit}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
    startEditVendor: (id, vendor) => dispatch(startEditVendor(id, vendor)),
});

export default connect(undefined, mapDispatchToProps)(EditVendorPage);



// WEBPACK FOOTER //
// ./src/components/admin/vendors/EditVendorPage.js